const InterSchoolData = [
    {
        thumb: '../img/xcl-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/9X9K6zyKIRU',
        img: '../img/xcl-main.jpg',
        title: 'XCL',
        fullTitle: 'XCL World Academy',
        student: '~1200명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S42,000',
        intro: '1959년에 GEMS Education의 싱가포르 국제학교로 2014년에 설립되었습니다. 두바이에 본사를 두고 있는 GEMS Education의 막대한 지원을 받아 싱가포르 내 국제학교들 중 최고의 캠퍼스 시설을 보유하고 있습니다. 최근에는 XCL World Academy로 교명을 변경하였고 대륙별로 전세계의 수많은 캠퍼스를 동시에 운영하며 세계 최고의 교육 환경을 제공하며 각 국가의 문화 교류 및 다양한 국외 활동 기회들이 주어집니다. 현재 60여개국의 국적의 학생들이 재학하고 있으며 캠퍼스 규모를 꾸준히 확장 중에 있습니다.'
    },
    {
        thumb: '../img/sais-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/KdXNNp0pbSs',
        img: '../img/sais-main.jpg',
        title: 'SAIS',
        fullTitle: 'Stamford American International School',
        student: '~3000명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S42,000',
        intro: '2009년에 설립된 이후 현재 75개국의 다양한 국제학생들이 재학중이며 캠퍼스 시설은 싱가포르 내에 국제학교들 중 손에 꼽을 정도로 최신 시설을 자랑합니다. 배움 이전에 인격을 성장시키는데 초점을 맞추어 학생들 개개인이 자신의 잠재력을 발견하고 계발하도록 하며 미래에 아이들이 자라 사회에 나갔을 때 사회의 한 일원으로서 자신의 본분에 최선을 다하는 글로벌 시대의 한 시민으로 성장하도록 비전을 갖고 교육하는 학교입니다. 학생 개개인이 먼저 접근하도록 유도하여 단순 지식적인 배움뿐 아니라 한 인격체로서 성장하도록 교육하는 커리큘럼을 자부하며 다른 국제학교들과 함께 많은 국제학생 학부모님들에게 사랑받는 학교입니다.'
    },
    {
        thumb: '../img/uwc-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/-EUoSsZzOJs',
        img: '../img/uwc-main.jpg',
        title: 'UWC',
        fullTitle: 'United World College',
        student: '~6000명',
        semester: '8월 - 12월 | 1월 - 3월 | 4월 - 7월',
        fee:'~$S45,000',
        intro: '세계적으로 유명한 싱가포르 전 총리 리콴유가 1971년 설립한 학교로 Dover Campus를 시작으로 2008년에는 East Campus로 확장하여 싱가포르내에 2개의 캠퍼스를 동시에 운영하고 있습니다. 90여개 다양한 국적의 학생들이 재학중에 있으며 전교생 수는 약 5,500명 정도입니다. 세계적으로 높은 명성을 자랑하며 학업적으로 선두에 앞장서는 국제학교로 잘 알려져 있습니다. 입학시험 수준이 높고 기숙사 시설을 같이 운영하며 엄격한 교내 시스템으로 학생들의 12년 학업 생활을 관리합니다.'
    },
    {
        thumb: '../img/sas-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/Jv-lIpQMn8w',
        img: '../img/sas-main.jpg',
        title: 'SAS',
        fullTitle: 'Singapore American School',
        student: '~4500명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S35,000',
        intro: '1956년에 설립되어 싱가포르 우드랜드 지역에 위치해 있습니다. 싱가포르 첫 국제학교로서 가장 긴 역사를 지닌 학교로 어느 국제학교와 견주어도 뒤지지 않으며 매년 전세계의 일류 명문 대학교로 졸업생들을 진학시키고 있으며 싱가포르 최고의 커리큘럼으로 자부하는 국제학교입니다. 현재 60개 국적의 약 4000명의 학생들이 재학중이며 한국학생은 약 6%정도로 다른 국제학교에 비해 한국학생이 적은 편에 속합니다. 재학생들 반 이상이 미국 시민권자이며 교사와 교직원들 대부분이 미국국적을 보유하고 있습니다. 입학조건이 매우 까다롭고 어렵지만 입학과 동시에 초일류 엘리트 미국 교육과정을 밟을 수 있습니다. ICS와 마찬가지로 미국 커리큘럼을 운영하여 12년 AP과정 및 SAT 시험대비 과정을 통해 대학에 진학하며 매년 졸업생들의 MAP 테스트 백분위등급이 94로 그 수준을 증명해주고 있습니다.'
    },
    {
        thumb: '../img/nis-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/CHyl-fHIhzQ',
        img: '../img/nis-main.jpg',
        title: 'NIS',
        fullTitle: 'Nexus International School',
        student: '~1100명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S40,000',
        intro: '2011년에 설립되어 창의적이고 열린 교육 방식을 통해 학생들의 비판적인 사고와 문제 해결 능력을 기르도록 장려하며 타인을 이해하고 돕는 인격 성장을 주된 교육 비전으로 합니다. 50개 이상의 다양한 국가의 국제 학생들이 재학중이며 전교생 수는 약 900명 정도입니다. 질 높은 교육은 실력을 갖추고 전문성이 있으며 가르침에 열정이 있는 교사들로부터 시작된다는 학교의 교육 철학을 바탕으로, 세계적으로 오랜 기간 아이들을 지도해오며 자질을 갖춰온 교육 전문가들로 교사진을 구성하고 있습니다. 특히 교사의 35% 이상이 박사 학위를 이수한 교육 전문가들로 그 명성이 높습니다.'
    },
    {
        thumb: '../img/ofs-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/L8Px5n7TkXA',
        img: '../img/ofs-main.jpg',
        title: 'OFS',
        fullTitle: 'Overseas Family School',
        student: '~3000명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S41,000',
        intro: '1991년에 설립된 학교로 싱가포르 내에 국제학교 중 ICS와 같이 긴 역사를 자랑하는 국제학교입니다. 학교 이름과 걸맞게 영어라는 공통언어를 통해 싱가포르에 거주하는 세계 각국의 부모들과 자녀들에게 현대적인 교육 커리큘럼을 제공하고자 최초 설립이 되어 현재까지도 많은 국제 학생들과 학부모들에게 사랑받는 학교입니다. 70여개 국가의 국제 학생들이 재학중이며 현재 약 3000명 정도의 학생들이 재학중입니다. 전 세계의 학생들을 특정 국가의 지배적인 색이나 국가적 정체성으로 나누지 않고 편견이 없는 환경 속에서 학교생활을 하고 글로벌 시대에 맞는 태도와 인격을 갖도록 교육합니다. OFS에서 지원하는 SPP(Study Preparation Programme – 학업준비프로그램)을 통해 다른 국제학교들이 운영하는 ESL (English as a Second Language)와는 다르게 영어를 모국어로 하지 않는 비영어권 국가의 학생들에게도 조금도 포용적입니다.'
    },
    {
        thumb: '../img/ics-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/10riq0-Ke0o',
        img: '../img/ics-main.jpg',
        title: 'ICS',
        fullTitle: 'International Community School',
        student: '~500명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S33,000',
        intro: '기독교를 중심으로 1993년에 설립된 싱가포르의 크리스천 국제학교로 전교생 수가 약 450명이고 20여개 국적의 학생들이 재학하고 있으며 교내 한국학생 수는 전체의 40% 정도로 미국학생 다음으로 많은 싱가포르내 많은 한인 자녀들이 선택하는 국제학교로 오랜 역사를 자랑하는 학교입니다. 소규모 그룹 수업을 선호하여 한반에 10명 내외의 학생들을 중심으로 수업하며 재학생 중 80% 이상이 졸업 이후 미국 대학으로 진학을 합니다. 비영리 교육사업을 추구하여 다양한 교내 외 활동을 제공하며 타 국제학교에 비교하여 저렴한 학비와 싱가포르 내 국제학교 중 싱가포르 미국 국제학교 (Singapore American School)과 함께 유일하게 미국 커리큘럼을 통해 미국 대학 진학 준비에 강점을 보이는 학교입니다.'
    },
    {
        thumb: '../img/ais-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/m5CaLVj9370',
        img: '../img/ais-main.jpg',
        title: 'AIS',
        fullTitle: 'Australian International School',
        student: '~2700명',
        semester: '1월 - 7월 | 8월 - 12월',
        fee:'~$S42,000',
        intro: '1991년에 설립된 싱가포르 호주 국제학교입니다. 남반부에 유일하게 호주 커리큘럼을 기반으로 한 글로벌 교육 시스템을 추구하는 국제학교로서 30년 가까운 시간동안 빠르게 성장해오며 호주국제 학교만의 우수한 교사들과 교직원들의 차별화된 교육시스템은 꾸준히 싱가포르 교육부와 수 많은 국제학생 학부모들에게 인정받아 왔습니다. 현재까지도 싱가포르 내에 명문 국제학교들과 어깨를 나란히 하는 학교로 그 명성이 높습니다. 교육과정은 IB프로그램을 운영하며 졸업생들의 평균 IB점수가 34.5 이상으로 많은 학생들을 세계 명문대학으로 진학시키고 있습니다. 재학생 중 50% 이상이 호주 국적의 학생들이며 50여개의 다양한 국가에서 싱가포르로 이주한 국제 학생들이 재학중에 있습니다. 전교생 수는 약 2700명 정도입니다.'
    },
    {
        thumb: '../img/cis-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/_m_da-ud8QA',
        img: '../img/cis-main.jpg',
        title: 'CIS',
        fullTitle: 'Canadian International School',
        student: '~3200명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S41,000',
        intro: '1990년에 대학 준비과정 컬리지 (College)로 설립되어 이후 서쪽 Lakeside 캠퍼스와 동쪽 Tanjong Katong 캠퍼스로 ‘Canadian International School Singapore’로 확장하여 자리를 잡아 현재까지 두개의 캠퍼스를 운영중인 캐나다 국제학교입니다. 교육 과정은 IB 프로그램이며 만 2세에서 18세까지 80여개 국가에서 온 약 3000여명의 학생들이 재학중입니다. 한국 학생은 전교생의 4-5% 정도입니다. 학생들이 도전의식을 갖고 폭 넓고 다양한 교육 및 활동들을 통해 배움에 주인의식을 가질 수 있도록 교육하는 것을 학교의 비전으로 삼아 지속적으로 변화하는 세계 무대 안에 학생들을 준비시키고 있습니다. 졸업생들의 IB 평균 점수는 2018년 기준 평균 34.4점으로 국제 평균 이상으로 학교의 위상이 날로 높아져가고 있습니다.'
    },
    {
        thumb: '../img/acsi-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/OAB_IoHK_7c',
        img: '../img/acsi-main.jpg',
        title: 'ACSI',
        fullTitle: 'Anglo-Chinese School International',
        student: '~1000명',
        semester: '1월 - 7월 | 8월 - 12월',
        fee:'~$S32,000',
        intro: '2005년에 싱가포르 감리교에 의해 설립되고 현재까지 운영되고 있으며 싱가포르 명문 공립 계열 Anglo Chinese School (ACS)의 국제학교입니다. 싱가포르 ACS School Family 재단의 학교로 ACS Primary School, ACS Junior School, ACS Secondary School (Barker Road), ACS Junior College, ACS Independent와 함께 역사가 깊은 공립 계열 명문 국제학교입니다. 교육과정은 6년 IB 프로그램이며 매년 재학생의 상당수가 IB시험에서 고득점으로 졸업하여 전세계의 수 많은 명문대로 진학하여 높은 명성을 자랑합니다. 재학생은 현재 30개국의 다양한 국적의 학생들이 재학중이며 재학생의 반절 이상이 싱가포르 현지 학생들입니다. 재학생 수는 약 1000명 정도이며 한국 학생들은 그 중 10%정도를 차지합니다.'
    },
    {
        thumb: '../img/dcis-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/WPh_Iy0Q9Qk',
        img: '../img/dcis-main.jpg',
        title: 'DCIS',
        fullTitle: 'Dover Court International School',
        student: '~1500명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S35,000',
        intro: '1972년에 설립되어 약 60여개국의 학생들이 재학중이며 전교생 수는 현재 1650명 정도입니다. 2018년에 The British International School Awards에서 Outstanding Senior Leadership Team of the Year Prize를 수상할 정도로 싱가포르 내 외에서 학생들의 배움에 있어서 포괄적인 접근 방식으로 높은 인정을 받고 있으며 2016년의 Christopher Short의 교장 취임 이후 꾸준히 글로벌 캠퍼스 확장을 하고 있으며 2019년엔 Secondary School 신축 건물이 완공되어 캠퍼스 규모가 확장되고 있습니다. 클래스당 평균 학생 교사 비율이 22:1 정도이며 줄리어드 음대 및 MIT 공대와 같이 세계에서 인정받는 명문 대학들과 함께 협력하여 학생들이 다양한 프로그램에 참여하며 다양한 기회들이 제공됩니다.'
    },
    {
        thumb: '../img/dcs-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/KnP5PHJQn0Y',
        img: '../img/dcs-main.jpg',
        title: 'DCS',
        fullTitle: 'Dulwich College Singapore',
        student: '~2500명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S46,000',
        intro: '1619 영국에서 설립된 Dulwich College International의 7번째 글로벌 캠퍼스로 2014년 Dulwich College Singapore입니다. 400년 전통의 영국 국제학교로 Dulwich College의 오랜 교육 철학을 그대로 반영하여 운영이 되고 있는 싱가포르 명문 국제학교입니다. 현재는 50% 이상의 영국계 학생들과 50여개국의 국제학생들이 재학중이며 전교생 수는 약 2000명입니다. 오랜 기간 교육의 선구자라는 타이틀을 지니며 정통 영국 교육 시스템을 통해 졸업생들 중 상당수가 세계 명문 대학교로 진학해왔습니다. 교육과정은 영국 교육과정 IB 프로그램을 운영 중이며 2017년 기준 IB 평균 37.3으로 싱가포르 내 국제학교들 중 최상위를 기록해오고 있습니다.'
    },
    {
        thumb: '../img/hcis-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/O09hgw2yVN0',
        img: '../img/hcis-main.jpg',
        title: 'HCIS',
        fullTitle: 'Hwa Chong International School',
        student: '~1000명',
        semester: '1월 - 7월 | 8월 - 12월',
        fee:'~$S30,000',
        intro: '2005년에 설립된 싱가포르 공립계열 국제학교로 Hwa Chong School의 뿌리를 두어 Anglo-Chinese School과 Saint Joseph Institution과 같이 싱가포르의 명문 공립학교의 깊고 오랜 교육 역사를 담고 있는 학교입니다. 현재 전교생 수는 800여명으로 50% 이상이 싱가포르 현지 학생 또는 영주권을 소지한 학생들이며 20여개 국적의 국제학생들이 재학중입니다. 6년 IB 프로그램을 교육과정으로 하며 매년 1, 2위에 랭크되는 Hwa Chong Institution의 명성과 같이 졸업생들의 IB 평균 점수가 35점 이상이며 2016년 이후 IB 만점자를 배출해내는 등 많은 학생들을 세계 각국의 명문대로 진학시키고 있습니다.'
    },
    {
        thumb: '../img/iss-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/W3O_tuciVGI',
        img: '../img/iss-main.jpg',
        title: 'ISS',
        fullTitle: 'ISS International School',
        student: '~600명',
        semester: '8월 - 12월 | 1월 - 7월',
        fee:'~$S41,000',
        intro: '아시아를 시작으로 세계로 뻗어 나가 싱가포르 국가의 발전에 이바지할 글로벌 리더를 양성하고자 싱가포르의 독립 이후 세워진 임시 정부의 멤버였던 Chan Chee Seng이 1981년에 설립한 싱가포르 국제학교입니다. 끝없는 변화를 추구하고 다중문화 교육환경을 학생들에게 제공해 단순한 학업 생활이 아니라 미래에 사회의 일원으로서 개개인의 인격 성장과 책임감을 교육하는데 무게를 두며 글로벌 시민의식을 갖도록 학생들을 지도하고 있습니다. 교육과정은 IB이고 현재 2개의 캠퍼스로 운영되고 있습니다. 약 50여개국의 국제학생들이 재학중이며 전교생 수는 약 600여명 정도로 소그룹 클래스를 지향하여 가족 같은 분위기 속에서 배움을 찾아갈 수 있는 국제학교입니다.'
    },
    {
        thumb: '../img/sjis-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/hdbtmrqA7Ic',
        img: '../img/sjis-main.jpg',
        title: 'SJII',
        fullTitle: 'St.Joseph International School',
        student: '~1800명',
        semester: '1월 - 7월 | 8월 - 12월',
        fee:'~$S38,000',
        intro: '2007년에 데 라 살레 형제들에 의해 설립되어 ACS와 동일하게 싱가포르 명문 공립학교 교육 시스템을 기반으로 세워진 Saint Joseph Institution의 국제학교로서 카톨릭 정신을 바탕으로 하며 국제학생들의 교육에 있어서 모든 영역에서 탁월함과 최고를 추구하도록 지도하여 그 명성이 자자합니다. 초등학교 6년 – Elementary School 그리고 중고등학교 6년 – High School을 운영하며 커리큘럼은 IB 프로그램입니다. 약 1800명의 학생들이 재학중이며 공립계열 국제학교인 만큼 재학생의 반절이 현지 싱가포르 국적의 학생들이며 외국인 재학생 수는 나머지 반절 정도입니다.'
    },
    {
        thumb: '../img/tts-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/DUXLKEkilN8',
        img: '../img/tts-main.jpg',
        title: 'TTS',
        fullTitle: 'Tanglin Trust School',
        student: '~2000명',
        semester: '1월 - 7월 | 8월 - 12월',
        fee:'~$S45,000',
        intro: '1925년에 싱가포르 내에 당시 해외에서 이주한 국제 학생들에게 영국 교육 시스템을 제공하기 위해 설립되었고 재학생 5명으로 시작하여 2022년 현재는 약 2800명의 다양한 국적의 학생들이 재학중입니다. 단순히 미래를 준비하는 공간을 넘어서 학생들이 매일 이어지는 학업속에 배움의 즐거움을 알고 기대속에 개개인의 잠재력을 기를 수 있도록 환경을 조성하는 것을 비전으로 삼는 교육의 철학이 깊은 국제학교입니다. 영국 교육 과정 IB 프로그램을 운영하여 재학생의 60% 이상이 영국계 학생들입니다.'
    },
]

export default InterSchoolData